import styled from 'styled-components'
import { device } from '../../../theme'

export const ResourcesWrapper = styled.section`
    padding-top: 40px;
    padding-bottom: 40px;
    background-color: #f8f8f8;
    position: relative;
`;

export const LeftBox = styled.div`
    max-width: 600px;
    padding-left: 30px;
    padding-right: 30px;
    margin-left: auto;
    @media ${device.medium}{
        margin-right: auto;
        text-align: center;
    }
`;

export const ImageBox = styled.div`
    text-align: center;
`;